<nav class="navbar navbar-expand navbar-dark bg-primary justify-content-between">
	<a class="navbar-brand" routerLink="">
		<i class="fa fa-clock-o"></i>
		{{ (season$ | async)?.name || 'Loading season...' }}
	</a>

	<div class="collapse navbar-collapse">
		<ul class="navbar-nav ml-auto">
			<li class="nav-item dropdown" routerLinkActive="active">
        <a href="#"
           routerLinkActive="active"
           class="nav-link dropdown-toggle"
           data-toggle="dropdown"
        >Races</a>
        <div class="dropdown-menu dropdown-menu-right">
          <a *ngFor="let racePlan of racePlans$ | async"
             [routerLink]="['/season/races/', racePlan._id | toUntypedId]"
             routerLinkActive="active"
             class="dropdown-item py-2"
          >{{ racePlan.name }}: <b>{{ racePlan.trackName }}</b></a>
        </div>
      </li>
<!--			<li class="nav-item dropdown" routerLinkActive="active">-->
<!--        <a href="#"-->
<!--           routerLinkActive="active"-->
<!--           class="nav-link dropdown-toggle"-->
<!--           data-toggle="dropdown"-->
<!--        >Races</a>-->
<!--        <div class="dropdown-menu dropdown-menu-right">-->
<!--          <a *ngFor="let racePlan of racePlans$ | async"-->
<!--             [routerLink]="['/season/race/', racePlan._id | toUntypedId]"-->
<!--             routerLinkActive="active"-->
<!--             class="dropdown-item py-2"-->
<!--          >{{ racePlan.name }}: <b>{{ racePlan.trackName }}</b></a>-->
<!--        </div>-->
<!--      </li>-->

      <li class="nav-item" routerLinkActive="active">
        <a class="nav-link" routerLink="/season/rankings" routerLinkActive="active">Season</a>
      </li>
      <li class="nav-item" routerLinkActive="active">
        <a class="nav-link" routerLink="/season/settings" routerLinkActive="active">
          <i class="fa fa-cog"></i>
        </a>
      </li>
    </ul>
  </div>
</nav>

<div class="container-fluid layout-content-wrapper">
	<div class="layout-content">
		<router-outlet></router-outlet>
	</div>
</div>
